import { render, staticRenderFns } from "./kaoshi.vue?vue&type=template&id=72baa6fe&scoped=true"
import script from "./kaoshi.vue?vue&type=script&lang=js"
export * from "./kaoshi.vue?vue&type=script&lang=js"
import style0 from "./kaoshi.vue?vue&type=style&index=0&id=72baa6fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72baa6fe",
  null
  
)

export default component.exports